module.exports = __webpack_public_path__ + "img/Graphic-Centered_grayscale.3c7d0e03.jpg";